/* PAWLY V11 · Panier tiroir (API AJAX Shopify) */
(function () {
  var d = document, C = window.PW_CART || { upsell: [], freeShip: 0, t: {} };
  var drawer, panel, items, upEl, totalEl, countEl, foot, shipEl, lastFocus, busy = false;
  var NBSP = new RegExp('[' + String.fromCharCode(8239) + String.fromCharCode(160) + ']', 'g');

  /* Même format de prix que le reste de la boutique (réglage Shopify), ex. €19,90 */
  function money(cents, cur) {
    var fmt = C.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var thousands = function (x, sep) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var vals = {
      amount: thousands(parts[0], ',') + '.' + parts[1],
      amount_no_decimals: thousands(String(Math.round(cents / 100)), ','),
      amount_with_comma_separator: thousands(parts[0], '.') + ',' + parts[1],
      amount_no_decimals_with_comma_separator: thousands(String(Math.round(cents / 100)), '.'),
      amount_with_space_separator: thousands(parts[0], ' ') + ',' + parts[1]
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return vals[k] != null ? vals[k] : m; }).replace(/<[^>]*>/g, '').replace(NBSP, ' ');
  }
  function esc(t) { var x = d.createElement('div'); x.textContent = t == null ? '' : String(t); return x.innerHTML; }
  function ballSvg() { return '<span class="pw-btn__ball" aria-hidden="true"><svg viewBox="0 0 100 100"><g class="pw-ball__spin"><circle class="pw-ball__body" cx="50" cy="50" r="50"/><path class="pw-ball__seam" d="M18 22 C40 38 40 62 18 78 M82 22 C60 38 60 62 82 78"/></g></svg></span>'; }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function setCount(n) {
    d.querySelectorAll('[data-pw-cart-open]').forEach(function (a) {
      var b = a.querySelector('.pw-cartcount');
      if (n > 0) { if (!b) { b = d.createElement('span'); b.className = 'pw-cartcount'; a.appendChild(b); } b.textContent = n; }
      else if (b) { b.remove(); }
      a.setAttribute('aria-label', 'Panier, ' + n + ' article' + (n > 1 ? 's' : ''));
    });
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.item_count) {
      items.innerHTML = '<div class="pw-cd__empty"><p>' + esc(C.t.empty) + '</p><a class="pw-btn" href="' + esc(C.t.emptyUrl) + '">' + esc(C.t.emptyCta) + ballSvg() + '</a></div>';
      foot.hidden = true; upEl.innerHTML = ''; shipEl.hidden = true; return;
    }
    foot.hidden = false;
    var html = '';
    /* Les cadeaux s'affichent après les articles achetés */
    var gift = function (it) { return it.properties && it.properties._offert ? 1 : 0; };
    cart.items.slice().sort(function (a, b) { return gift(a) - gift(b); }).forEach(function (it) {
      var props = '';
      if (it.properties) Object.keys(it.properties).forEach(function (k) {
        var v = it.properties[k]; if (k.charAt(0) === '_' || v == null || v === '') return;
        props += '<li><span>' + esc(k) + '</span> ' + esc(v) + '</li>';
      });
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="pw-cd__var">' + esc(it.variant_title) + '</p>' : '';
      html += '<div class="pw-cd__item" data-key="' + esc(it.key) + '">' +
        '<a class="pw-cd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="" width="90" height="90" loading="lazy">' : '') + '</a>' +
        '<div class="pw-cd__info"><a class="pw-cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        (props ? '<ul class="pw-cd__props">' + props + '</ul>' : '') +
        '<div class="pw-cd__row">' + (it.requires_shipping === false
          /* Produit numérique (e-book, carte) : un seul exemplaire suffit, pas de +/- */
          ? '<span class="pw-cd__digital">' + esc(C.t.digital || 'Numérique') + '</span>'
          : '<div class="pw-cd__qty" role="group" aria-label="Quantité">' +
            '<button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Retirer un">&minus;</button><span>' + it.quantity + '</span>' +
            '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button></div>') +
        price(it, cart) + '</div>' +
        '<button type="button" class="pw-cd__rm" data-q="0">' + esc(C.t.remove) + '</button></div></div>';
    });
    items.innerHTML = html;
    totalEl.textContent = money(cart.total_price, cart.currency);

    /* Seuls les produits à expédier comptent : e-books et carte ne font pas avancer la jauge */
    var shipTotal = 0;
    cart.items.forEach(function (it) { if (it.requires_shipping) shipTotal += it.final_line_price; });
    if (C.freeShip > 0 && shipTotal > 0) {
      shipEl.hidden = false;
      var left = C.freeShip - shipTotal, pct = Math.min(100, Math.round(shipTotal / C.freeShip * 100));
      shipEl.querySelector('[data-cd-ship-text]').textContent = left > 0 ? C.t.shipLeft.replace('{montant}', money(left, cart.currency)) : C.t.shipOk;
      shipEl.querySelector('[data-cd-ship-bar]').style.width = pct + '%';
      shipEl.classList.toggle('is-ok', left <= 0);
    } else { shipEl.hidden = true; }

    var inCart = {}, blocked = {}, pref = {};
    (C.owned || []).forEach(function (h) { blocked[String(h).trim()] = 1; });
    cart.items.forEach(function (it) {
      inCart[it.product_id] = 1;
      ((C.exclude || {})[it.handle] || []).forEach(function (h) { blocked[String(h).trim()] = 1; });
      ((C.prefer || {})[it.handle] || []).forEach(function (h) { pref[String(h).trim()] = 1; });
    });
    var ok = function (p) { return !inCart[p.pid] && !(p.handle && blocked[p.handle]); };
    /* D'abord un produit « à proposer en priorité » pour ce panier, sinon le premier de la liste */
    var u = null;
    (C.upsell || []).some(function (p) { if (ok(p) && pref[p.handle]) { u = p; return true; } return false; });
    if (!u) (C.upsell || []).some(function (p) { if (ok(p)) { u = p; return true; } return false; });
    var nb = neighbour(inCart, blocked);
    if (nb && u && nb.pid === u.pid) u = null;
    /* Calendrier dans le panier : aucune suggestion, seulement l'emballage cadeau */
    var quiet = cart.items.some(function (it) { return (C.noUp || []).some(function (h) { return String(h).trim() === it.handle; }); });
    if (quiet) { u = null; nb = null; }
    var wrapRow = wrapOption(cart);
    var nbTitle = C.packPct > 0 ? (C.t.nbPack || '').replace('[pct]', C.packPct) : C.t.nbTitle;
    upEl.innerHTML = wrapRow + (u ? upCard(C.t.upTitle, u, cart) : '') + (nb ? upCard(nbTitle, nb, cart) : '');
  }

  /* Emballage cadeau : proposé tant qu'il y a un produit à expédier et qu'il n'est pas déjà dans le panier */
  function wrapOption(cart) {
    var w = C.wrap; if (!w) return '';
    var ships = false, has = false;
    cart.items.forEach(function (it) { if (it.product_id === w.pid) has = true; else if (it.requires_shipping) ships = true; });
    if (!ships || has) return '';
    return '<label class="pw-cd__wrap"><input type="checkbox" data-cd-wrap><span>' + esc(C.t.wrap) + '</span><b>+' + money(w.price, cart.currency) + '</b></label>';
  }
  function addWrap() { return req('/cart/add.js', { items: [{ id: C.wrap.id, quantity: 1 }] }); }

  /* Ligne passée à 0 € par une réduction (cadeau) : prix barré + « Offert » */
  function price(it, cart) {
    if (it.final_line_price === 0 && it.original_line_price > 0) {
      return '<b class="pw-cd__free"><s>' + money(it.original_line_price, cart.currency) + '</s> ' + esc(C.t.free || 'Offert') + '</b>';
    }
    return '<b>' + money(it.final_line_price, cart.currency) + '</b>';
  }

  /* Produit offert avec l'article ajouté (ex. carte avec le calendrier), s'il n'est pas déjà dans le panier.
     La propriété cachée _offert garde le lien, pour le retirer si l'article acheté est retiré. */
  function addGift(handle) {
    var g = (C.gifts || {})[handle]; if (!g) return Promise.resolve();
    return req('/cart.js').then(function (cart) {
      if (cart.items.some(function (it) { return it.product_id === g.pid; })) return;
      return req('/cart/add.js', { items: [{ id: g.id, quantity: 1, properties: { _offert: handle } }] });
    });
  }

  /* Cadeau resté seul (article acheté retiré) : on le retire, sinon il serait facturé */
  function dropOrphans(cart) {
    var handles = {}, orphans = [];
    cart.items.forEach(function (it) { handles[it.handle] = 1; });
    cart.items.forEach(function (it) { var by = it.properties && it.properties._offert; if (by && !handles[by]) orphans.push(it.key); });
    if (!orphans.length) return Promise.resolve(cart);
    var upd = {}; orphans.forEach(function (k) { upd[k] = 0; });
    return req('/cart/update.js', { updates: upd }).then(function (c) {
      if (!drawer && /^\/cart\/?$/.test(location.pathname)) location.reload();
      return c;
    });
  }

  function upCard(title, u, cart) {
    return '<p class="pw-cd__uptitle">' + esc(title) + '</p><div class="pw-cd__upcard">' +
      '<a class="pw-cd__img" href="' + esc(u.url) + '">' + (u.img ? '<img src="' + esc(u.img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
      '<div class="pw-cd__info"><a class="pw-cd__name" href="' + esc(u.url) + '">' + esc(u.title) + '</a><b>' + money(u.price, cart.currency) + '</b>' + varSelect(u) + '</div>' +
      '<button type="button" class="pw-cd__upadd" data-up="' + u.id + '">' + esc(C.t.add) + ballSvg() + '</button></div>';
  }

  /* Produit à plusieurs variantes (ex. tailles) : le client choisit avant d'ajouter */
  function varSelect(u) {
    if (!u.vars || u.vars.length < 2) return '';
    var label = u.opt || 'Option';
    return '<select class="pw-cd__upsel" data-up-sel aria-label="' + esc(label) + '"><option value="" selected disabled>' + esc(label) + ' ?</option>' +
      u.vars.map(function (v) { return '<option value="' + v.id + '">' + esc(v.t) + '</option>'; }).join('') + '</select>';
  }

  /* E-book de la ville voisine d'un e-book déjà dans le panier (et pas encore pris) */
  function neighbour(inCart, blocked) {
    var books = C.ebooks || [], byCity = {}, found = null;
    books.forEach(function (b) { byCity[b.city.toLowerCase()] = b; });
    books.some(function (b) {
      if (!inCart[b.pid]) return false;
      var list = (C.neighbours || {})[b.city] || [];
      return list.some(function (name) {
        var n = byCity[String(name).trim().toLowerCase()];
        if (n && !inCart[n.pid] && !blocked[n.handle]) { found = n; return true; }
        return false;
      });
    });
    return found;
  }

  function req(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', headers: body ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); });
  }
  function refresh() { return req('/cart.js').then(dropOrphans).then(render); }
  function lock(on) { busy = on; if (panel) panel.classList.toggle('is-busy', on); }

  function open() {
    if (!drawer) { location.href = '/cart'; return; }
    lastFocus = d.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); d.body.classList.add('pw-noscroll');
    setTimeout(function () { panel.focus(); }, 60);
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); d.body.classList.remove('pw-noscroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init() {
    drawer = d.getElementById('pw-cd');
    /* Page panier (pas de tiroir) : on nettoie quand même les cadeaux orphelins */
    if (!drawer) { req('/cart.js').then(dropOrphans).catch(function () {}); return; }
    panel = drawer.querySelector('.pw-cd__panel'); items = drawer.querySelector('[data-cd-items]'); upEl = drawer.querySelector('[data-cd-up]');
    totalEl = drawer.querySelector('[data-cd-total]'); countEl = drawer.querySelector('[data-cd-count]'); foot = drawer.querySelector('[data-cd-foot]'); shipEl = drawer.querySelector('[data-cd-ship]');
    refresh().catch(function () {});
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { close(); return; }
      var q = e.target.closest('[data-q]');
      if (q && !busy) {
        var key = q.closest('[data-key]').getAttribute('data-key');
        lock(true); req('/cart/change.js', { id: key, quantity: Math.max(0, parseInt(q.getAttribute('data-q'), 10)) }).then(dropOrphans).then(render).catch(function () {}).then(function () { lock(false); });
        return;
      }
      var up = e.target.closest('[data-up]');
      if (up && !busy) {
        var sel = up.parentNode.querySelector('[data-up-sel]');
        if (sel && !sel.value) { sel.classList.add('is-needed'); sel.focus(); return; }
        var vid = sel ? sel.value : up.getAttribute('data-up');
        lock(true); req('/cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }] }).then(refresh).catch(function () {}).then(function () { lock(false); });
      }
    });
    drawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cd-wrap]') || busy || !C.wrap) return;
      lock(true); addWrap().then(refresh).catch(function () {}).then(function () { lock(false); });
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pw-cart-open]');
    if (a && d.getElementById('pw-cd')) { e.preventDefault(); refresh().catch(function () {}); open(); }
  });

  d.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-pw-ajax]'); if (!f || !d.getElementById('pw-cd')) return;
    e.preventDefault(); if (busy) return;
    var btn = f.querySelector('[type="submit"]'); if (btn) btn.classList.add('is-loading');
    /* Formulaire envoy\u00e9 tel quel : garde la quantit\u00e9, les personnalisations et l'abonnement (selling_plan de Seal) */
    var toCheckout = f.getAttribute('data-pw-mode') === 'checkout';
    lock(true);
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      /* Produit offert avec cet article (la carte avec le calendrier) */
      .then(function (added) { return addGift(added && added.handle); })
      /* Case « emballage cadeau » cochée sur la page produit : on l'ajoute juste après */
      .then(function () { var w = f.querySelector('[data-wrap]:checked'); if (w && C.wrap) return addWrap(); })
      .then(function () { if (toCheckout) { location.href = '/checkout'; return; } return refresh().then(open); })
      .catch(function (err) { alert((err && err.description) || 'Impossible d\u2019ajouter ce produit.'); })
      .then(function () { lock(false); if (btn) btn.classList.remove('is-loading'); });
  });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  window.PawlyCart = { open: open, close: close, refresh: refresh };
})();